/**
 * Converte qualsiasi datetime in formato data italiana: gg/mm/aaaa
 * Esempio: 2026-03-15T14:32:10 → 15/03/2026
 */
export function formatDateIT(value) {
  if (!value) return "";

  const d = new Date(value);

  if (isNaN(d.getTime())) return "";

  return d.toLocaleDateString("it-IT");
}

/**
 * Converte datetime in formato italiano con ora
 * Esempio: 2026-03-15T14:32:10 → 15/03/2026 14:32
 */
export function formatDateTimeIT(value) {
  if (!value) return "";

  const d = new Date(value);

  if (isNaN(d.getTime())) return "";

  return d.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Converte datetime in formato ISO per input type="date"
 * Esempio: 2026-03-15T14:32:10 → 2026-03-15
 */
export function toISODate(value) {
  if (!value) return "";

  const d = new Date(value);

  if (isNaN(d.getTime())) return "";

  return d.toISOString().split("T")[0];
}

/**
 * Verifica se un valore è una data valida
 */
export function isValidDate(value) {
  if (!value) return false;

  const d = new Date(value);

  return !isNaN(d.getTime());
}

/**
 * Rileva automaticamente se una colonna è data
 */
export function isDateColumn(columnName) {
  if (!columnName) return false;

  const name = columnName.toUpperCase();

  return (
    name.includes("DATA") ||
    name.includes("DATE") ||
    name.includes("CREATED") ||
    name.includes("UPDATED")
  );
}

/**
 * Formatter automatico per DataGrid
 */
export function autoFormatValue(value, columnName) {
  if (isDateColumn(columnName)) {
    return formatDateIT(value);
  }

  return value ?? "";
}